/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_File_Extension_LabelInputs */

const en_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Extension`)
};

const fr_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension de fichier`)
};

const de_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateierweiterung`)
};

const it_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estensione del file`)
};

const ru_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширение файла`)
};

const es_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensión de archivo`)
};

const zh_cn2_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件扩展名`)
};

const ja_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル拡張子`)
};

const hi_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फाइल एक्सटेंशन`)
};

const pt_pt2_subtitle_export_file_extension_label = /** @type {(inputs: Subtitle_Export_File_Extension_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensão de arquivo`)
};

/**
* | output |
* | --- |
* | "File Extension" |
*
* @param {Subtitle_Export_File_Extension_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_file_extension_label = /** @type {((inputs?: Subtitle_Export_File_Extension_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_File_Extension_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_file_extension_label(inputs)
	if (locale === "de") return de_subtitle_export_file_extension_label(inputs)
	if (locale === "it") return it_subtitle_export_file_extension_label(inputs)
	if (locale === "ru") return ru_subtitle_export_file_extension_label(inputs)
	if (locale === "es") return es_subtitle_export_file_extension_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_file_extension_label(inputs)
	if (locale === "ja") return ja_subtitle_export_file_extension_label(inputs)
	if (locale === "hi") return hi_subtitle_export_file_extension_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_file_extension_label(inputs)
	return en_subtitle_export_file_extension_label(inputs)
});